import { render, staticRenderFns } from "./reporting-customer-chart.vue?vue&type=template&id=2dcc496a&scoped=true&"
import script from "./reporting-customer-chart.vue?vue&type=script&lang=js&"
export * from "./reporting-customer-chart.vue?vue&type=script&lang=js&"
import style0 from "./reporting-customer-chart.vue?vue&type=style&index=0&id=2dcc496a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcc496a",
  null
  
)

export default component.exports